<script>
	import Avatar from "./components/Avatar.svelte";
	import Navigation from "./components/Navigation.svelte";
	import TLDRContent from "./components/TLDRContent.svelte";
	import LongStoryContent from './components/LongStoryContent.svelte';
	import NotWorkingContent from './components/NotWorkingContent.svelte';
	import FindMeContent from './components/FindMeContent.svelte';

	let currentSection = "tldr";

	function onSectionChange(event) {
		currentSection = event.detail.sectionId;
	}
</script>

<main>
	<Avatar />
	<div class="nav-wrapper">
		<Navigation on:sectionChange={onSectionChange}/>
	</div>

	{#if currentSection === "tldr"}
		<TLDRContent />
	{/if}
	{#if currentSection === "longStory"}
		<LongStoryContent />
	{/if}
	{#if currentSection === "notWorking"}
		<NotWorkingContent />
	{/if}
	{#if currentSection === "findMe"}
		<FindMeContent />
	{/if}
</main>

<style>
	@import url('https://fonts.googleapis.com/css2?family=Inconsolata:wght@300;400;500;600;700&display=swap');

	main {
		font-family: 'Inconsolata',  monospace;
		text-align: center;
		padding: 1em;
		max-width: 640px;
		margin: 0 auto;
	}

	.nav-wrapper {
		margin: 2em 0;
	}
</style>